<template>
  <v-dialog
      v-model="dialog"
      :width="dialogWidth"
      @keydown.enter.prevent="onenter"
  >
    <v-card
        class="resizable-card"
        :class="{ 'no-select': resizing }"
        :style="{ height: dialogHeight + 'px' }"
    >
      <v-card-title>
        <span class="headline">Product ({{ this.rules.name }})</span>
        <v-spacer/>
        <r-authorize
            :master="masterAccess"
            :locked.sync="model.locked"
            :enabled.sync="model.enabled"
        />
      </v-card-title>
      <v-card-text class="resizable-card__body">
        <v-col cols="4" sm="2" md="2">
          <v-btn @click="showPreview()" class="mr-2" small>View JSON</v-btn>
        </v-col>
        <v-row dense class="mt-3">
          <v-col cols="12" md="12" sm="12" class="mb-n5">
            <v-text-field
                :disabled="!(rules.id === 0 || rules.id === 3)"
                label="ID:"
                v-model.trim="model.id"
                v-ascii-only
                outlined
                dense
            />
          </v-col>
          <v-col>
            <v-text-field
                label="Name:"
                v-model.trim="model.name"
                v-ascii-only
            />
          </v-col>

          <v-col>
            <v-text-field
                label="Key:"
                v-model.trim="model.key"
                v-ascii-only
            />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="4">
            <v-text-field
                label="Segment"
                v-model.trim="model.segment"
                v-ascii-only
            />
          </v-col>
          <v-col cols="12" md="2" sm="2">
            <v-checkbox class="sm" v-model="model.segmentStart" label="Segment Start" hide-details/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" md="2" sm="2">
            <v-checkbox class="sm" v-model="model.consumable" label="Consumable" hide-details/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" md="2" sm="2">
            <v-checkbox class="sm" v-model="model.stashSupport" label="Stash supported" hide-details/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" md="2" sm="2">
            <r-tile label="Place" :model.sync="model.place" label-tile-x="Row:" label-tile-y="Column:" hide-details/>
          </v-col>
          <v-col cols="12" md="2" sm="2">
            <v-text-field label="Marker" v-model.number="model.marker" hide-details/>
          </v-col>
          <v-col cols="12" md="2" sm="2">
            <v-text-field label="Percent" v-model.number="model.percent" hide-details/>
          </v-col>
          <v-col cols="12" md="2" sm="2">
            <v-text-field label="Priority" v-model.number="model.priority" hide-details/>
          </v-col>
          <v-col cols="12" md="2" sm="2">
            <v-text-field label="Sticker" v-model.number="model.sticker" hide-details/>
          </v-col>
          <v-col cols="12" md="2" sm="2">
            <v-text-field label="Display:" v-model.number="model.display" hide-details/>
          </v-col>
          <v-col cols="12" md="2" sm="2">
            <v-text-field label="Quantity:" v-model.number="model.quantity" hide-details/>
          </v-col>
          <v-col cols="12" md="2" sm="2">
            <v-text-field label="Discount:" v-model.number="model.discount" hide-details/>
          </v-col>
          <v-col cols="12" md="2" sm="2">
            <v-text-field label="Freeuse:" v-model.number="model.freeuse" hide-details/>
          </v-col>
          <v-col cols="12" md="2" sm="2">
            <v-text-field label="Free time:" v-model.number="model.freetime" hide-details/>
          </v-col>
          <v-col cols="12" md="2" sm="2">
            <v-text-field label="Reset time:" v-model.number="model.resettime" hide-details/>
          </v-col>
        </v-row>
        <v-row dense class="mt-6">
          <v-expansion-panels>
            <r-guard-panel :model.sync="model.guard"/>
            <v-expansion-panel>
              <v-expansion-panel-header v-slot="{ open }" den>
                <v-row no-gutters>
                  <span style="margin-top: 5px">Payment</span>
                  <v-spacer/>
                  <v-fade-transition>
                    <span style="display: inline-flex" v-if="open">
                      <v-divider class="mx-1" vertical/>
                    </span>
                  </v-fade-transition>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-divider/>
                <v-radio-group v-model="model.payment" row hide-details>
                  <v-col cols="3">
                    <v-radio label="LOCAL" :value="0"/>
                  </v-col>
                  <v-col cols="3">
                    <v-radio label="STORE" :value="1"/>
                  </v-col>
                  <v-col cols="3">
                    <v-radio label="AD" :value="3"/>
                  </v-col>
                  <v-col cols="3">
                    <v-radio label="SURVEY" :value="2"/>
                  </v-col>
                </v-radio-group>
                <v-row v-if="model.payment === 0" dense class="mt-2">
                  <r-currency-table :items.sync="model.price" title="Price"/>
                </v-row>
                <v-row v-else-if="model.payment === 1" dense class="mt-2">
                  <r-store-bundle-table :items.sync="model.bundles" title="Store Bundles"/>
                </v-row>
                <v-row v-else-if="model.payment === 2" dense>
                  <v-col cols="12" class="mb-4">
                    <v-text-field label="Survey" v-model.trim="model.survey" hide-details/>
                  </v-col>
                </v-row>
                <v-row v-else-if="model.payment === 3" dense>
                  <v-col cols="12" md="6">
                    <r-ad-placement-dropdown :model.sync="model.adPlacement" title="Ad Placement" hide-details/>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <r-reward-bunch-panel :model.sync="model.rewardBunch" title="Rewards" label="Range:" :points="true"/>
            <r-stash-bonus-bunch-panel :model.sync="model.stashBonusBunch" title="Rewards Stash" label="Range:" :points="true"/>
            <r-currency-panel v-if="model.resettime>0" :items.sync="model.resetPrice" title="Reset Price"/>
          </v-expansion-panels>
        </v-row>
      </v-card-text>
      <v-card-actions class="resizable-card__actions">
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text v-if="!lockedAssess || masterAccess">
          Save
        </v-btn>
      </v-card-actions>
      <div class="resize-handle" @mousedown="startResize"></div>
      <r-preview-dialog ref="preview-dialog"></r-preview-dialog>
    </v-card>
  </v-dialog>
</template>

<script>
import {ViewRules} from "@/common/ViewRules";
import {ProductModel} from "@/modules/redactor/models/product/ProductModel";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

import RAuthorize from "@/modules/redactor/views/common/r-authorize";
import RTile from "@/modules/redactor/views/utils/r-tile.vue";
import RGuardPanel from "@/modules/redactor/views/guard/r-guard-panel";
import RCurrencyTable from "@/modules/redactor/views/currency/r-currency-table";
import RCurrencyPanel from "@/modules/redactor/views/currency/r-currency-panel.vue";
import RRewardBunchPanel from "@/modules/redactor/views/reward/r-reward-bunch-panel.vue";
import RAdPlacementDropdown from "@/modules/redactor/views/ad-settings/placement/r-ad-placement-dropdown.vue";
import RStoreBundleTable from "@/modules/redactor/views/product/r-store-bundle-table.vue";
import RPreviewDialog from "@/modules/redactor/views/preview/r-preview-dialog.vue";
import RStashBonusBunchPanel from "@/modules/redactor/views/stash/r-stash-bonus-bunch-panel.vue";

export default {
  name: "r-product-dialog",
  components: {
    RPreviewDialog,
    RStoreBundleTable, RAdPlacementDropdown, RRewardBunchPanel, RTile, RCurrencyPanel, RAuthorize, RCurrencyTable, RGuardPanel, RStashBonusBunchPanel},
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: new ProductModel(),
    rules: ViewRules.READONLY,
    dialogWidth: 747,
    dialogHeight: 776,
    resizing: false,
    resizeStartX: 0,
    resizeStartY: 0,
    resizeStartWidth: 747,
    resizeStartHeight: 776,
    viewportPadding: 32
  }),
  computed: {
    lockedAssess() {
      return this.model.locked;
    },
    masterAccess() {
      return RedactorUtils.hasMasterAccess();
    }
  },
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new ProductModel();

      if (ViewRules.COPY.equal(this.rules)) {
        this.model.locked = false;
      }

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
      this.stopResize();
    },
    onenter() {
      if (!this.lockedAssess || this.masterAccess) {
        this.save();
      } else {
        this.cancel();
      }
    },
    startResize(e) {
      this.resizing = true;
      this.resizeStartX = e.clientX;
      this.resizeStartY = e.clientY;
      this.resizeStartWidth = this.dialogWidth;
      this.resizeStartHeight = this.dialogHeight;
      window.addEventListener("mousemove", this.onResize);
      window.addEventListener("mouseup", this.stopResize);
    },
    onResize(e) {
      if (!this.resizing) return;
      const dx = e.clientX - this.resizeStartX;
      const dy = e.clientY - this.resizeStartY;
      let newWidth = this.resizeStartWidth + dx;
      let newHeight = this.resizeStartHeight + dy;
      const minWidth = 500;
      const minHeight = 400;
      if (newWidth < minWidth) newWidth = minWidth;
      if (newHeight < minHeight) newHeight = minHeight;
      this.dialogWidth = newWidth;
      this.dialogHeight = newHeight;
    },
    stopResize() {
      if (!this.resizing) return;
      this.resizing = false;
      window.removeEventListener("mousemove", this.onResize);
      window.removeEventListener("mouseup", this.stopResize);
    },
    showPreview() {
      this.$refs['preview-dialog'].show(this.rules, this.model, ProductModel)
          .then((result) => {
            Object.assign(this.model, result);
          })
          .catch((e) => {
            this.$alert("Failed to parse config!" + e.message);
          });
    }
  },
  beforeDestroy() {
    window.removeEventListener("mousemove", this.onResize);
    window.removeEventListener("mouseup", this.stopResize);
  }
};
</script>

<style lang="css" scoped>
:read-only {
  white-space: nowrap;
}

.resizable-card {
  position: relative;
  display: flex;
  flex-direction: column;
}

.resizable-card__body {
  flex: 1;
  overflow: auto;
}

.resizable-card__actions {
  flex-shrink: 0;
}

.resize-handle {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 14px;
  height: 14px;
  cursor: se-resize;
  border-right: 2px solid rgba(0, 0, 0, 0.3);
  border-bottom: 2px solid rgba(0, 0, 0, 0.3);
}

.no-select {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
</style>